module.exports = __webpack_public_path__ + "img/JP_Tagline_black.2a4a8428.png";